<a
  #overlayOrigin="cdkOverlayOrigin"
  overlay-origin
  [innerHTML]="'app.common.learn_more' | translate | rtPreventOrphans"
  class="infobox-link"
  (click)="overlay()!.toggleOverlay()"
></a>
<rt-anonymous-learn-more-overlay [origin]="overlayOrigin" [anonymousStage]="anonymousStage()" />
